export default "__VITE_PUBLIC_ASSET__f23ecfae__"